import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import IconButton from "@mui/material/IconButton";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { getAssignmentWiseClassData } from "../Services";
import { getAssignmentLearnerSummaryLogPrint } from "../Services";
import PolarChart from "./PolarChart";
import { getUsersByRoleId } from "../../Users/Services";
import { map, find, startCase } from "lodash";
import { joinByKeys } from "../../../Js/Common";
import { getFormatedDate } from "../../../Js/TimeAndDate";
import html2pdf from "html2pdf.js";
import Certificate from "./Certificate";

const AssignmentWiseSkills = () => {
  const styles = useStyles();
  // Hooks

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const serverRole = useSelector((state) => state.defs.serverRole);
  const { siteConfig } = useSelector((state) => state.defs);

  const { paramsdata } = useSelector((state) => state.common);

  //State
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedClassName, setSelectedClassName] = useState(null);
  const [assignmentSummaryLog, setAssignmentSummaryLog] = useState(null);
  const [certiFlag, setCertiFlag] = useState(false);

  // React logic hooks
  useEffect(() => {
    console.log("HeatmapList===>", paramsdata);
    const getInitialData = async () => {
      let params = {
        query: {
          learners: paramsdata.reportData.learners.learners,
          site_uuid: userInfo.site_uuid,
        },
      };
      let res = await getAssignmentWiseClassData(null, params);
      // console.log("res.classesList=====>", res.classesList);
      setClasses(res.classesList);
    };
    getInitialData();
  }, [paramsdata, userInfo]);

  useEffect(() => {
    //console.log("paramsdata selectedClass====>", paramsdata.selectedClass);
    if (classes && paramsdata.selectedClass !== undefined) {
      let classObj = classes.find((classData) => {
        return classData.value == paramsdata.selectedClass;
      });
      if (classObj) {
        return handleClassChange(classObj);
      }
    }
  }, [classes, paramsdata.selectedClass]);

  const handleClassChange = (itemData) => {
    setSelectedClass(itemData.value);
    setSelectedClassName(itemData.label);
    getUserIds(itemData.value);
  };

  const getUserIds = async (classid) => {
    let users = await getUsersByRoleId({
      query: {
        $select: ["uid", "name"],
        belongs_to: classid,
        site_uuid: userInfo.site_uuid,
        $limit: -1,
      },
    });
    getSummaryData(users.data);
  };

  const getSummaryData = async (users) => {
    let params = {
      query: {
        $select: ["uid", "outcome", "verb", "actor"],
        target: paramsdata.reportData.uid,
        actor: map(users, "uid"),
        outcome: {
          attemptedAssets: {
            $gt: 0,
          },
        },
        site_uuid: userInfo.site_uuid,
        $limit: -1,
      },
    };
    let resSummaryLogs = await getAssignmentLearnerSummaryLogPrint(params);

    console.log("resSummaryLogs", resSummaryLogs);
    let newArr = resSummaryLogs.data.map((val, ind) => {
      return {
        ...val,
        name: find(users, { uid: val.actor }).name,
      };
    });
    console.log("resSummaryLogs===>", newArr);
    setAssignmentSummaryLog(newArr);
  };

  const downloadPDF = () => {
    var element = document.getElementById("pdfid");
    var opt = {
      margin: certiFlag ? 0 : [20, 15, 0, 0],
      filename: certiFlag
        ? `certificate_${selectedClassName}.pdf`
        : `perfomancereport_${selectedClassName}.pdf`,
      jsPDF: {
        unit: "pt",
        format: "a4",
        orientation: certiFlag ? "portrait" : "landscape",
      },
    };
    //html2pdf(element,opt);
    html2pdf().from(element).set(opt).toPdf().save();
  };
  const getOverallGrade = (valGrade) => {
    let gradeVal = ((+valGrade.score / +valGrade.totalAssets) * 100).toFixed(2);
    // console.log("gradeVal====>",gradeVal,"valGrade===>",valGrade);
    if (gradeVal >= 90 && gradeVal <= 100) {
      return "A* (Outstanding)";
    } else if (gradeVal >= 75 && gradeVal < 90) {
      return "A (Excellent)";
    } else if (gradeVal >= 56 && gradeVal < 75) {
      return "B (Very Good)";
    } else if (gradeVal >= 35 && gradeVal < 56) {
      return "C (Good)";
    } else if (gradeVal < 35) {
      return "D (Average)";
    }
  };

  function downloadCSV() {
    let dataTransform = assignmentSummaryLog.map((val) => {
      let skillwiseObj = val.outcome.skillwise.reduce((acc, obj) => {
        if (obj["name"] !== undefined) {
          acc[obj["name"]] = (
            (+obj["score"] / +obj["totalAssets"]) *
            100
          ).toFixed(2);
        }
        return acc;
      }, {});
      return {
        name: joinByKeys(val.name, ["firstname", "lastname"], " ").trim(),
        ...skillwiseObj,
      };
    });
    let data = dataTransform;
    if (!data || !data.length) {
      console.error("No data to export");
      return;
    }

    // Extract headers (keys)
    const headers = Object.keys(data[0]);
    const visualHeaders = Object.keys(data[0]).map((key) => startCase(key));

    // Convert rows
    const csvRows = [];
    csvRows.push(visualHeaders.join(",")); // header row
    for (const row of data) {
      const values = headers.map((header) => {
        const val = row[header] ?? "";
        // Escape double quotes
        return `${String(val).replace(/"/g, '""')}`;
      });
      csvRows.push(values.join(","));
    }

    // Build CSV content
    const csvContent = csvRows.join("\n");

    // Create Blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `skillwise_report.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mx: 6 }}>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <Grid container spacing={0} sx={{ marginTop: "20px" }}>
              <Grid item xs={8}></Grid>
              <Grid item xs={2}>
                <List style={{ display: "inline-flex", textAlign: "rigth" }}>
                  {assignmentSummaryLog && assignmentSummaryLog.length > 0 && (
                    <>
                      <ListItem
                        sx={{ mt: 4.5, p: 0, ml: 5 }}
                        secondaryAction={
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setCertiFlag((val) => {
                                return !val;
                              });
                            }}
                          >
                            {!certiFlag &&
                              serverRole == "WEB_HOST" &&
                              userInfo.rolesInfo.title.toLowerCase() ==
                                "admin" && (
                                <WorkspacePremiumIcon
                                  sx={{ fontSize: "2vw" }}
                                />
                              )}
                            {certiFlag && (
                              <DonutSmallIcon sx={{ fontSize: "2vw" }} />
                            )}
                          </IconButton>
                        }
                      />
                      {process.env.REACT_APP_DOWNLOAD_ALLOW == "true" && (
                        <>
                          <ListItem
                            sx={{ mt: 4.5, p: 0, ml: 5 }}
                            secondaryAction={
                              <IconButton color="primary" onClick={downloadPDF}>
                                <CloudDownloadIcon sx={{ fontSize: "2vw" }} />
                              </IconButton>
                            }
                          />
                          <ListItem
                            sx={{ mt: 4.5, p: 0, ml: 5 }}
                            secondaryAction={
                              <IconButton color="primary" onClick={downloadCSV}>
                                <FileDownloadIcon sx={{ fontSize: "2vw" }} />
                              </IconButton>
                            }
                          />
                        </>
                      )}
                    </>
                  )}
                </List>
              </Grid>
              <Grid item xs={2} sx={{ px: 4 }}>
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          px: 1,
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#DB8829",
                          "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                        }}
                      >
                        Select Classes
                      </Typography>
                    }
                  />
                  <Select
                    value={selectedClass}
                    sx={{
                      borderRadius: 20,
                      borderColor: "#DB8829",
                      width: "15ch",
                      color: "#DB8829",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                        width: "20ch",
                        mt: 0.5,
                      },
                    }}
                    // onChange={handleClassChange}
                  >
                    {classes.map((itemData, index) => (
                      <MenuItem
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                        }}
                        key={`${index}_Class`}
                        value={itemData.value}
                        onClick={() => {
                          handleClassChange(itemData);
                        }}
                      >
                        {itemData.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={0}
              className={styles.scrollBar}
              sx={{ height: "73vh", overflow: "auto", marginTop: "20px" }}
            >
              {assignmentSummaryLog && assignmentSummaryLog.length > 0 && (
                <Box id="pdfid">
                  {assignmentSummaryLog.map((val, index) => {
                    return (
                      <>
                        {index > 0 && <div class="html2pdf__page-break"></div>}
                        {certiFlag && (
                          <Certificate
                            name={joinByKeys(
                              val.name,
                              ["firstname", "lastname"],
                              " "
                            )}
                            class={selectedClassName}
                            institute={siteConfig.customer.customerName}
                            grade={getOverallGrade(val.outcome)}
                            date={getFormatedDate(new Date(), "DD-MMM-YYYY")}
                          ></Certificate>
                        )}
                        {!certiFlag && (
                          <Grid container>
                            <Grid item>
                              <Grid
                                container
                                sx={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <Grid
                                  item
                                  xs={2}
                                  sx={{
                                    borderRight: 2,
                                    borderColor: "#CCCCCC",
                                  }}
                                >
                                  <img
                                    src={require("../../../assets/logo.png")}
                                    width="80%"
                                  ></img>
                                </Grid>
                                <Grid item xs={10} sx={{ px: 2 }}>
                                  <Typography
                                    fontSize={"1rem"}
                                    fontWeight={600}
                                    sx={{ color: "#DB8829" }}
                                  >
                                    {"Vocablab English Language System"}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.8rem",
                                      fontWeight: 600,
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.1rem",
                                      },
                                    }}
                                  >
                                    {siteConfig && siteConfig.customer && (
                                      <span>
                                        Institute Name:{" "}
                                        {siteConfig.customer.customerName}
                                      </span>
                                    )}
                                  </Typography>
                                  <Typography
                                    fontSize={"0.8rem"}
                                    fontWeight={500}
                                    sx={{ color: "#DB8829" }}
                                  >
                                    {joinByKeys(
                                      val.name,
                                      ["firstname", "lastname"],
                                      " "
                                    )}{" "}
                                    - {`(${selectedClassName})`}
                                    {" | Performance Report"} -{" "}
                                    {getFormatedDate(new Date(), "DD-MMM-YYYY")}
                                  </Typography>
                                  {/* <Typography fontSize={"0.8rem"} fontWeight={500} sx={{ color: '#DB8829', }}>
                                                                        {'Overall Grade: '} - {getOverallGrade(val.outcome)}
                                                                    </Typography> */}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  mt: 2,
                                  borderTop: 2,
                                  pt: 2,
                                  borderTopColor: "#cccccc",
                                  borderTopStyle: "dashed",
                                  width: "70%",
                                }}
                                key={`${index}_polar`}
                              >
                                <PolarChart polarChartData={val} />
                                <Typography
                                  fontSize={"0.8rem"}
                                  variant="caption"
                                  sx={{ color: "#aaa" }}
                                >
                                  <span style={{ fontWeight: "800" }}>
                                    Note:
                                  </span>
                                  <br />
                                  A* - 90-100 Outstanding
                                  <br />
                                  A - 75-89 Excellent
                                  <br />
                                  B - 56-74 Very Good
                                  <br />C - 35-55 Good
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </Box>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default AssignmentWiseSkills;
